import React from "react";
import { Select } from '@mantine/core';
import { utils } from "../../utils/globalVariables";

import InputWrapperCustom from "../general/InputWrapperCustom";

const BarangDPBiayaMetodeDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={stateData.data.label}
                stateWithAsterisk={stateData.data.withAsterisk}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
            >
                <Select
                    readOnly
                    value={stateData.data.value}
                    data={[
                        { value: '', label: 'Tidak ada data' },
                        ...Object.values(utils.metodeBayar).map(key => ({ value: key.value, label: key.caption }))
                    ]}

                    styles={(tema) => ({
                        input: {
                            backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                        }
                    })}
                />
            </InputWrapperCustom>
        </React.Fragment>
    )
}

export default BarangDPBiayaMetodeDibatalkan;